import ModalInfo from 'components/shared/ModalInfo'
import { FormattedMessage, useIntl } from 'react-intl'
import Text from 'components/shared/Text'
import { useSpaCart } from './hooks/useSpaCart'
import { useEffect } from 'react'

interface SpaConfirmDeleteModalProps {
    isOpened: boolean
    onClose: () => void
    onSubmit: () => void
}

export const SpaConfirmDeleteModal = ({
    isOpened,
    onClose,
    onSubmit,
}: SpaConfirmDeleteModalProps) => {
    const { formatMessage } = useIntl()
    const { deleteSpaFromCart, isDeleteSpaLoading, isDeleteSpaSuccess } =
        useSpaCart()

    const handleReset = () => onClose()

    const handleAccept = () => deleteSpaFromCart()

    useEffect(() => {
        isDeleteSpaSuccess && onSubmit()
    }, [isDeleteSpaSuccess])

    return (
        <ModalInfo
            isOpened={isOpened}
            linkLabel={formatMessage({
                id: 'global.btn.dont_remove',
                defaultMessage: 'Nie usuwaj',
            })}
            buttonLabel={formatMessage({
                id: 'global.btn.remove',
                defaultMessage: 'Usuń',
            })}
            onButtonClick={handleAccept}
            onLinkClick={handleReset}
            variant="secondary"
            width={430}
            isLoading={isDeleteSpaLoading}
        >
            <Text variant="heading3">
                <FormattedMessage
                    id="upsells.wellness.are_you_sure_deleting"
                    defaultMessage="Czy na pewno chcesz usunąć wszystkie zabiegi z koszyka?"
                />
            </Text>
            <Text variant="body" color="grayscale_900" mt={16}>
                <FormattedMessage
                    id="upsells.wellness.one_way_operation_warning"
                    defaultMessage="Nie będziemy mogli ich przywrócić."
                />
            </Text>
        </ModalInfo>
    )
}
